export const KEY_UP = 'ArrowUp'
export const KEY_DOWN = 'ArrowDown'
export const KEY_RIGHT = 'ArrowRight'
export const KEY_LEFT = 'ArrowLeft'

export const KEY_ENTER = 'Enter'

export const KEY_DIGIT = {
  EIGHT: 'Digit8',
  FIVE: 'Digit5',
  FOUR: 'Digit4',
  NINE: 'Digit9',
  ONE: 'Digit1',
  SEVEN: 'Digit7',
  SIX: 'Digit6',
  THREE: 'Digit3',
  TWO: 'Digit2',
}

type Shortcut = Record<
  'openAppSelector' | 'navigateTable' | 'openFavouriteView' | 'easterEgg',
  { codes: string[]; keys: ('altKey' | 'shiftKey' | 'ctrlKey')[] }
>

export const shortcut: Shortcut = {
  easterEgg: { codes: ['KeyQ', 'KeyN', 'KeyT'], keys: ['altKey'] },
  navigateTable: { codes: [KEY_UP, KEY_DOWN, KEY_ENTER], keys: [] },
  openAppSelector: { codes: ['KeyK'], keys: ['ctrlKey'] },
  openFavouriteView: {
    codes: [
      KEY_DIGIT.ONE,
      KEY_DIGIT.TWO,
      KEY_DIGIT.THREE,
      KEY_DIGIT.FOUR,
      KEY_DIGIT.FIVE,
      KEY_DIGIT.SIX,
      KEY_DIGIT.SEVEN,
      KEY_DIGIT.EIGHT,
      KEY_DIGIT.NINE,
    ],
    keys: ['ctrlKey'],
  },
}
